
import { GetItemsProps, getDate, toISOString, } from "medere-ui-framework";
import { BudgetDTO } from "../../dto/budget/BudgetDTO";
import { axiosInstance } from "../../App";
import { ComboDataDTO } from "../../dto/ComboDataDTO";
import { PatientPreInvoiceItem } from "../../dto/budget/PatientPreInvoiceItem";

import { DistributionStructureDTO } from "../../dto/budget/DistributionStructureDTO";

export function getNomenclatorValue(nomenclator:number, date:Date | undefined, healthEntityPlan:number | undefined) {
  return axiosInstance.get('/api/secured/contract/getNomenclatorValue', {
    params: {
      nomenclator,
      UTCDate:date?.getTime(),
      healthEntityPlan: healthEntityPlan
    }
  }).then((response) => {
      return response.data;
  }).catch(() => {
      return null; // El contrato no tiene valor
  });
}

export function getProfessionalActivities({ filterValue, offSet, pageSize, params }: GetItemsProps) {
  return axiosInstance.get('/api/secured/budget/getProfessionalActivities', {
      params: {
          offSet,
          pageSize,
          inputText: filterValue ?? '',
          orderByNomenclatorType: params.orderByNomenclatorType,
          healthEntity: params.healthEntity ?? -1
      }
  }).then((response) => {
      return response.data;
  }).catch((error) => {
      console.error(error);
      throw error;
  });
}

export function getEquipments({ filterValue, offSet, pageSize, params }: GetItemsProps) {
  return axiosInstance.get('/api/secured/budget/getEquipments', {
      params: {
          offSet,
          pageSize,
          inputText: filterValue ?? '',
          orderByNomenclatorType: params.orderByNomenclatorType,
          healthEntity: params.healthEntity ?? -1
      }
  }).then((response) => {
      return response.data;
  }).catch((error) => {
      console.error(error);
      throw error;
  });
}

export function getNutritionalSupport({filterValue,offSet,pageSize}:GetItemsProps) {
  return axiosInstance.get('/api/secured/budget/getNutritionalSupport', {
    params: {
      offSet,
      pageSize,
      inputText:filterValue??'',
    }
  }).then((response) => {
    return response.data;
  }).catch((error) => {
    console.error(error);
    throw error;
  });
}

export function getMedicines({filterValue,offSet,pageSize}:GetItemsProps) {
  return axiosInstance.get('/api/secured/budget/getMedicines', {
    params: {
      offSet,
      pageSize,
      inputText:filterValue??'',
    }
  }).then((response) => {
    return response.data;
  }).catch((error) => {
    console.error(error);
    throw error;
  });
}

export function getDisposablesStockItemsForCombo({filterValue,offSet,pageSize}:GetItemsProps) {
  return axiosInstance.get('/api/secured/budget/getDisposablesStockItemsForCombo', {
    params: {
      offSet,
      pageSize,
      inputText:filterValue??'',
    }
  }).then((response) => {
    return response.data;
  }).catch((error) => {
    console.error(error);
    throw error;
  });
}

export function getStockItemPresentationValue(id:number) {
  return axiosInstance.get('/api/secured/budget/getStockItemPresentationValue', {
    params: {
      stockitempresentation:id
    }
  }).then((response) => {
      return response.data;
  }).catch(() => {
      return null; // No hay valor para ese item
  });
}

export function getBudgetStates({filterValue,offSet,pageSize}:GetItemsProps) {
  return axiosInstance.get('/api/secured/budget/getBudgetStates', {
    params: {
      offSet,
      pageSize,
      inputText:filterValue??''
    }
  }).then((response) => {
    return response.data;
  }).catch((error) => {
    console.error(error);
    throw error;
  });
}

export function getBudgetViewModes({filterValue,offSet,pageSize}:GetItemsProps) {
  return axiosInstance.get('/api/secured/budget/getBudgetViewModes', {
    params: {
      offSet,
      pageSize,
      inputText:filterValue??''
    }
  }).then((response) => {
    return response.data;
  }).catch((error) => {
    console.error(error);
    throw error;
  });
}

export function getBudgetDetailLevels({filterValue,offSet,pageSize}:GetItemsProps) {
  return axiosInstance.get('/api/secured/budget/getBudgetDetailLevels', {
    params: {
      offSet,
      pageSize,
      inputText:filterValue??''
    }
  }).then((response) => {
    return response.data;
  }).catch((error) => {
    console.error(error);
    throw error;
  });
}

export function getAllBudgets (offset:number, pageSize:number, params:any): Promise<BudgetDTO[]>{
  return axiosInstance.post('/api/secured/budget/getAllBudgets',{
      offSet:offset,
      pageSize,
      filters: params.filterDTO,
      sortingFieldInfoList: params.multiSortMeta
  },
  {
      params:{
          filterAddressee:params.filterAddressee,
          filterHealthEntity:params.filterHealthEntity,
          filterBudgetId:params.filterBudgetId,
          UTCfilterDate:params.filterDate?.getTime(),
          filterDetail:params.filterDetail,
          filterState:params.filterState,
          filterHospitalization:params.filterHospitalization
      }
  }).then((response) => {
      return response.data;
  }).catch((error) => {
      console.error(error);
  })
}

export function getBudgetComplete(id: number): Promise<BudgetDTO> {
  return axiosInstance.get('/api/secured/budget/getBudgetComplete', {
    params: {
      budgetId: id,
    },
  })
  .then((response) => response.data)
  .catch((error) => {
    console.error(error);
    throw error;
  });
}

export function duplicateBudget(id: number, withUpdatedPrices: boolean): Promise<BudgetDTO> {
  return axiosInstance.get('/api/secured/budget/duplicateBudget', {
    params: {
      budgetId: id,
      withUpdatedPrices: withUpdatedPrices
    },
  })
  .then((response) => response.data)
  .catch((error) => {
    console.error(error);
    throw error;
  });
}

export function updateBudgetPrices(budget: BudgetDTO): Promise<BudgetDTO> {
  return axiosInstance.post('/api/secured/budget/updateBudgetPrices', budget)
  .then((response) => response.data)
  .catch((error) => {
    console.error(error);
    throw error;
  });
}

export function exportBudgetPDF(id: number, viewMode: number, detailLevel: number) {
  return axiosInstance
    .get('/api/secured/budget/exportBudgetPDF', {
      params: { budgetId: id, viewMode, detailLevel },
      responseType: 'blob',
    })
    .then((response) => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `presupuesto_${id}.pdf`;

      document.body.appendChild(a);
      a.click();

      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }, 0);
    })
    .catch((error) => {
      console.error('Error al descargar el PDF:', error);
      throw error;
    });
}

export function saveBudget (budget:BudgetDTO){
  return axiosInstance.post('/api/secured/budget/saveBudget',{...budget, date:toISOString(getDate(budget.date)), laststatechange:toISOString(getDate(budget.laststatechange))}).then(res => res);
}

export function changeBudgetState(budget: number, state: number) {
  return axiosInstance.put('/api/secured/budget/changeBudgetState',{}, { params: { budget, state } }).then(res => res);
}

export function cancelBudget(budget: number) {
  return axiosInstance.put('/api/secured/budget/cancelBudget',{}, { params: { budget} }).then(res => res.data);
}

export function getPatientForBudget(budget:BudgetDTO) {
  return axiosInstance.post('/api/secured/budget/getPatientForBudget', {...budget, date:toISOString(getDate(budget.date)), laststatechange:toISOString(getDate(budget.laststatechange))}).then(res => res);
}

export function getModalities({filterValue,offSet,pageSize}:GetItemsProps) {
  return axiosInstance.get('/api/secured/budget/getModalities', {
    params: {
      offSet,
      pageSize,
      inputText:filterValue??''
    }
  }).then((response) => {
    return response.data;
  }).catch((error) => {
    console.error(error);
    throw error;
  });
}

export function getBillingEntities({filterValue,offSet,pageSize}:GetItemsProps) {
  return axiosInstance.get('/api/secured/budget/getBillingEntities', {
    params: {
      offSet,
      pageSize,
      inputText:filterValue??'',
    }
  }).then((response) => {
    return response.data;
  }).catch((error) => {
    console.error(error);
    throw error;
  });
}

export function generateBenefitOrderFromBudget (budget:BudgetDTO){
  return axiosInstance.post('/api/secured/budget/generateBenefitOrderFromBudget',{...budget, date:toISOString(getDate(budget.date)), laststatechange:toISOString(getDate(budget.laststatechange))},{}).then(res => res);
}

export function getServiceTypesAndSupplies(): Promise<ComboDataDTO[]> {
  return axiosInstance.get('/api/secured/budget/getServiceTypesAndSupplies').then((response) => {
    return response.data;
  }).catch((error) => {
      console.error(error);
      throw error;
  });
}

export function getPatientPreInvoiceItems (offset:number, pageSize:number, params:any): Promise<PatientPreInvoiceItem[]>{
  return axiosInstance.post('/api/secured/budget/getPatientPreInvoiceItems',{
      loadConfig: { offSet: offset, pageSize },
      patientId:params.patientId,
      serviceTypeAndSuppliesOptions:params.serviceTypeAndSuppliesOptions,
      UTCtoDate:params.toDate?.getTime(),
      UTCfromDate:params.fromDate?.getTime()
  }).then((response) => {
      return response.data;
  }).catch((error) => {
      console.error(error);
  })
}

export function getProfessionals({ filterValue, offSet, pageSize }: GetItemsProps) {
    return axiosInstance.get('/api/secured/budget/getProfessionals', {
        params: {
            offSet,
            pageSize,
            inputText: filterValue ?? '',
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getProfessionalRoles({ filterValue, offSet, pageSize }: GetItemsProps) {
    return axiosInstance.get('/api/secured/budget/getProfessionalRoles', {
        params: {
            offSet,
            pageSize,
            inputText: filterValue ?? '',
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getDistributionStructures({ filterValue, offSet, pageSize }: GetItemsProps): Promise<DistributionStructureDTO[]> {
    return axiosInstance.get('/api/secured/budget/getDistributionStructures', {
        params: {
            offSet,
            pageSize,
            inputText: filterValue ?? '',
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}


export function createDistributionStructure(structure: DistributionStructureDTO) {
    return axiosInstance.post('/api/secured/budget/createDistributionStructure', structure)
        .then((response) => response.data)
        .catch((error) => {
            console.error(error);
            throw error;
        });
}

export function useBudgetService() {
  return {
    getNomenclatorValue,
    getProfessionalActivities,
    getEquipments,
    getNutritionalSupport,
    getMedicines,
    getDisposablesStockItemsForCombo,
    getStockItemPresentationValue,
    getBudgetStates,
    getBudgetViewModes,
    getBudgetDetailLevels,
    getAllBudgets,
    getBudgetComplete,
    duplicateBudget,
    updateBudgetPrices,
    exportBudgetPDF,
    saveBudget,
    changeBudgetState,
    cancelBudget,
    getPatientForBudget,
    getModalities,
    getBillingEntities,
    generateBenefitOrderFromBudget,
    getServiceTypesAndSupplies,
    getPatientPreInvoiceItems,
    getProfessionals,
    getProfessionalRoles,
    getDistributionStructures,
    createDistributionStructure,
  }
}
